var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5465 10.5003C1.328 10.5003 1.1405 10.422 0.984 10.2655C0.828 10.1095 0.75 9.92201 0.75 9.70301C0.75 9.57801 0.78125 9.43751 0.84375 9.28151C0.90625 9.12501 0.9845 9.00501 1.0785 8.92151L4.7655 5.50001L1.0785 2.07851C0.9845 1.99501 0.90625 1.87776 0.84375 1.72676C0.78125 1.57576 0.75 1.43251 0.75 1.29701C0.75 1.07801 0.828 0.890506 0.984 0.734506C1.1405 0.578006 1.328 0.499756 1.5465 0.499756H7.281C7.552 0.499756 7.78125 0.593506 7.96875 0.781006C8.15625 0.968506 8.25 1.19776 8.25 1.46876C8.25 1.73976 8.15625 1.96901 7.96875 2.15651C7.78125 2.34401 7.552 2.43776 7.281 2.43776H3.84375L6.1095 4.53101C6.2555 4.66651 6.36225 4.81751 6.42975 4.98401C6.49725 5.15101 6.531 5.32301 6.531 5.50001C6.531 5.67701 6.49725 5.84901 6.42975 6.01601C6.36225 6.18251 6.2555 6.33351 6.1095 6.46901L3.84375 8.56226H7.281C7.552 8.56226 7.78125 8.65601 7.96875 8.84351C8.15625 9.03101 8.25 9.26026 8.25 9.53126C8.25 9.80226 8.15625 10.0315 7.96875 10.219C7.78125 10.4065 7.552 10.5003 7.281 10.5003H1.5465Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSum);
export default __webpack_public_path__ + "static/media/sum.49f547f71d3e13da5ec85f65620ec6c2.svg";
export { ForwardRef as ReactComponent };